import styled from 'styled-components';
import React, { FC, useCallback, useRef } from 'react';
import { RowV2, ColV2, BoxV2, EmptyStateV2 } from '@cubeyou-team/hx-react-components';
import uniqid from 'uniqid';
import UkMapChart from '../UkMapChart';

const StyledMultipleUkMapChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #ffffff;
  padding: 10px;
`;

type MultipleUkMapChartProps = {
  type: string;
  data: any[];
  metric: string;
  showMoreDetail: boolean;
  onItemClick: (item: any) => void;
  emptyDataMessage: string;
  horizontalLayout?: boolean;
  colors: any;
};

const MultipleUkMapChart: FC<MultipleUkMapChartProps> = ({
  type = 'states',
  data,
  metric,
  showMoreDetail,
  onItemClick,
  emptyDataMessage,
  horizontalLayout,
  colors
}) => {
  const chartId = useRef(uniqid());
  const isEmpty = !data || data.length === 0;
  const keys = (!isEmpty && Object.keys(data[0].metrics)) || [];

  const getUkMapChartData = useCallback(
    (key) => {
      return data.map((d) => {
        return {
          id: d.id,
          insight_type: d.insight_type,
          label: d.label,
          pic: d.pic,
          ...d.metrics[key]
        };
      });
    },
    [data, metric]
  );

  if (isEmpty) {
    return (
      <StyledMultipleUkMapChartWrapper>
        <BoxV2 minWidth='100%'>
          <EmptyStateV2
            icon='analytics'
            mainText={emptyDataMessage}
            size='large'
          />
        </BoxV2>
      </StyledMultipleUkMapChartWrapper>
    );
  }
  return (
    <StyledMultipleUkMapChartWrapper>
      <RowV2
        valign='equal'
        halign={horizontalLayout ? 'left' : 'center'}
        style={{ height: '100%' }}
      >
        {keys.map((key, index) => (
          <ColV2
            span={horizontalLayout && keys.length > 2 ? 4 : 6}
            key={`multiple-uk-map-chart-${chartId.current}-${index}`}
          >
            <BoxV2 style={{ height: '100%' }}>
              <UkMapChart
                data={getUkMapChartData(key)}
                metric={metric}
                showMoreDetail={showMoreDetail}
                onItemClick={onItemClick}
                color={colors[key]}
                emptyDataMessage={emptyDataMessage}
                positionLegend={horizontalLayout ? 'bottom' : 'left'}
              />
            </BoxV2>
          </ColV2>
        ))}
      </RowV2>
    </StyledMultipleUkMapChartWrapper>
  );
};
export default MultipleUkMapChart;
